'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Link": "Polaris-Link",
  "monochrome": "Polaris-Link--monochrome",
  "removeUnderline": "Polaris-Link--removeUnderline"
};

exports.default = styles;
